import React from 'react';
import { CalendarCheck, CreditCard, Zap, QrCode } from 'lucide-react';

const STEPS = [
  { icon: CalendarCheck, title: 'اختر الملعب والوقت', desc: 'تصفح الملاعب المتاحة واختر الموعد الأنسب لك في ثوانٍ' },
  { icon: CreditCard, title: 'دفع فوري وآمن', desc: 'تحصيل قيمة الحجز مباشرة عبر مدى وآبل باي، وفاتورة تصلك لحظياً' },
  { icon: Zap, title: 'تفعيل تلقائي', desc: 'تُفعَّل إضاءة الملعب تلقائياً وتصلك رسالة واتساب بكل التفاصيل' },
  { icon: QrCode, title: 'دخول بلا تذاكر', desc: 'رمز QR فريد لحجزك يفتح لك بوابة الملعب دون أي تذكرة ورقية' },
];

export function FeaturesGrid() {
  return (
    <div>
      <h3 className="mb-1 text-2xl font-bold text-white">كيف يعمل الحجز الذكي؟</h3>
      <p className="mb-6 text-sm text-slate-400">من اختيار الملعب إلى الدخول الفعلي — أربع خطوات فقط</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="features-grid">
        {STEPS.map((s, i) => (
          <div key={s.title} className="relative rounded-2xl border border-white/10 bg-[#1E2D4A] p-5 transition-colors hover:border-teal-400/40" data-testid="feature-card-item">
            <span className="absolute left-4 top-4 text-3xl font-black text-white/5">{i + 1}</span>
            <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-teal-400/15 text-teal-300">
              <s.icon className="h-5 w-5" />
            </div>
            <h4 className="mb-1.5 text-sm font-bold text-white">{s.title}</h4>
            <p className="text-xs leading-relaxed text-slate-400">{s.desc}</p>
            {i < STEPS.length - 1 && (
              <div aria-hidden className="absolute -left-2.5 top-1/2 hidden h-px w-5 -translate-y-1/2 border-t border-dashed border-teal-400/30 lg:block" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
